<template>
  <AuthenticatedLayout>
    <div class="scan-center-wrapper">
      <NovoScanFolhetoTable />
    </div>
  </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import NovoScanFolhetoTable from "@/views/components/NovoScanFolhetoTable.vue";

export default {
  name: "NovoScanFolheto",
  components: {
    AuthenticatedLayout,
    NovoScanFolhetoTable,
  },
};
</script>

<style scoped>
.scan-center-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
}
</style>
